import { useState } from "react";

const placeholderDataUri = (label) => {
  const name = (label || "BathLane").replace(/&/g, "&amp;").replace(/"/g, "&quot;");
  const svg = `<svg xmlns='http://www.w3.org/2000/svg' width='450' height='600' viewBox='0 0 450 600'><rect width='450' height='600' fill='#EAE4DA'/><rect x='0' y='0' width='450' height='600' fill='none' stroke='#D9D0C2' stroke-width='1'/><circle cx='225' cy='290' r='86' fill='none' stroke='#B9AE9C' stroke-width='1'/><text x='225' y='268' text-anchor='middle' font-family='Georgia, serif' font-size='84' fill='#A99D8A'>${name.charAt(0).toUpperCase()}</text><text x='225' y='430' text-anchor='middle' font-family='Helvetica, Arial, sans-serif' font-size='20' letter-spacing='6' fill='#908878'>BATHLANE</text></svg>`;
  return `data:image/svg+xml,${encodeURIComponent(svg)}`;
};

export const SmartImage = ({ src, alt = "", label, className, ...rest }) => {
  const [failed, setFailed] = useState(false);

  if (failed || !src) {
    return (
      <img
        src={placeholderDataUri(label || alt)}
        alt={alt}
        className={className}
        {...rest}
      />
    );
  }

  return (
    <img
      src={src}
      alt={alt}
      className={className}
      onError={() => setFailed(true)}
      {...rest}
    />
  );
};

export default SmartImage;
